import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { ParrainageDao } from '@app/dao/parrainage/parrainage.dao';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';
import { EaParrainageFormBuilder } from './ea-parrainage-form.builder';

@Component({
    selector: 'ea-parrainage-form',
    templateUrl: './ea-parrainage-form.component.html',
    styleUrls: ['./ea-parrainage-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaParrainageFormComponent),
        },
    ],
    standalone: false
})
export class EaParrainageFormComponent
  extends EaParrainageFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();

  constructor(
    protected formConstructor: PrFormConstructor,
    private parrainageDao: ParrainageDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {}

  onSubmit() {
    this.prFormService.loading();
    let dto = this.extract();
    this.parrainageDao.saveParrainage(dto).subscribe(
      success => {
        this.prFormService.loaded();
        this.doneSubject.next();
        if (this.callback) this.callback(success);
        this.notificationService.success('La sauvegarde a réussi');
      },
      errors => {
        if (errors.status == 409) {
          this.notificationService.error(
            "Un compte a déja été créé pour l'email <b>" + dto.email + '</b>',
          );
        } else {
          this.notificationService.error('La sauvegarde a échoué');
        }
        this.prFormService.loaded();
      },
    );
  }
}
